import * as Scrivito from "scrivito";
import defaultSocialHeaderButtonAttributes from "../_defaultSocialHeaderButtonAttributes";

const XingSocialHeaderButton = Scrivito.provideObjClass(
  "XingSocialHeaderButton",
  defaultSocialHeaderButtonAttributes,
);

export default XingSocialHeaderButton;
